export default __webpack_public_path__ + "static/media/trophy-gold.914c418d.svg";